// src/components/ServicesSection.jsx
import React from "react";
import { Container, Card } from "react-bootstrap";
import {
  FaGlobe,
  FaPalette,
  FaUsers,
  FaCog,
  FaArrowRight,
  FaChartLine,
  FaBuilding,
  FaBook,
  FaTruck,
} from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "./ServicesSection.css";

import service1 from "../assets/1.jpg";
import service2 from "../assets/2.jpg";
import service3 from "../assets/3.jpg";
import service4 from "../assets/4.jpg";
import service5 from "../assets/5.jpg";
import service6 from "../assets/6.jpg";


const ServicesSection = () => {
  const services = [
    {
      icon: <FaGlobe />,
      title: "Government & Public",
      desc: "Digital governance, smart city initiatives.",
      img: service1,
    },
    {
      icon: <FaPalette />,
      title: "Healthcare",
      desc: "Hospital IT systems, patient record management.",
      img: service2,
    },
    {
      icon: <FaUsers />,
      title: "Telecommunications",
      desc: "Fiber-to-the-Home (FTTH), enterprise connectivity.",
      img: service3,
    },
    {
      icon: <FaCog />,
      title: "Retail & E-Commerce",
      desc: "POS integrations, CRM, customer analytics.",
      img: service4,
    },
    {
      icon: <FaChartLine />,
      title: "Education & Training",
      desc: "Digital learning platforms, secure networks.",
      img: service5,
    },
    {
      icon: <FaBuilding />,
      title: "Trade & Supply Chain",
      desc: "Sourcing, procurement, and cross-border trade solutions.",
      img: service6,
    },
   
  ];

  return (
    <section className="services-section py-5">
      <Container>
        <p className="text-orange1 fw-bold">Our Service List</p>
        <h2
          className="fw-bold mb-5"
          style={{ maxWidth: "750px", fontSize: "48px" }}
        >
          We Provide the Digital Foundation Manufacturers Need to Grow
        </h2>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
          }}
        >
          {services.map((service, idx) => (
            <SwiperSlide key={idx}>
              <Card className="service-card h-100 shadow-sm">
                <Card.Body>
                  <div className="service-icon">{service.icon}</div>
                  <Card.Title className="fw-bold">{service.title}</Card.Title>
                  <Card.Text>{service.desc}</Card.Text>
                  <div className="service-img">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="img-fluid"
                    />
                    <div className="arrow-overlay">
                      <FaArrowRight />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default ServicesSection;
